import * as ReactDOM from 'react-dom/client';
import 'moment/dist/locale/pt-br';

import './tailwind.css';
import Dashboard from './Dashboard';
import { preserveInitialLoadingElement } from './pages/LoadingPage/initialLoadingElement';

async function bootstrap() {
  preserveInitialLoadingElement();

  // Demo mode: load MSW + seed data BEFORE rendering so the first network
  // call from the React tree is already intercepted. Dynamic import means
  // prod bundles tree-shake this entire branch away (vite-plugin-environment
  // inlines the env var at build time).
  if (process.env.REACT_APP_DEMO_MODE === 'true') {
    try {
      const { startDemoWorker } = await import('@cobliteam/msw-demo');
      await startDemoWorker();
    } catch (err) {
      console.error('Failed to start demo worker:', err);
    }
  }

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(<Dashboard />);
}

bootstrap();
